var _path, _rect, _path2, _path3, _rect2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandlestickChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-chart-candlestick",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5v4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6,
    x: 7,
    y: 9,
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15v2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3v2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 8,
    x: 15,
    y: 5,
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v16a2 2 0 0 0 2 2h16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandlestickChart);
export default __webpack_public_path__ + "static/media/candlestick-chart.da5a150b771f1fd94edfbcf47b423970.svg";
export { ForwardRef as ReactComponent };